var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VcUpsellBlock',_vm._b({class:{'image-resize': _vm.asset === 'thryv'},attrs:{"mode":_vm.blockMode,"image-url":_vm.image,"icon":"$check_circle_fill"},on:{"buttonClick":_vm.goToUpgrade}},'VcUpsellBlock',_vm.upsellProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }